"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateBrandMerchantBodyToJSON = exports.UpdateBrandMerchantBodyFromJSONTyped = exports.UpdateBrandMerchantBodyFromJSON = void 0;
function UpdateBrandMerchantBodyFromJSON(json) {
    return UpdateBrandMerchantBodyFromJSONTyped(json, false);
}
exports.UpdateBrandMerchantBodyFromJSON = UpdateBrandMerchantBodyFromJSON;
function UpdateBrandMerchantBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createMaps': json['createMaps'],
    };
}
exports.UpdateBrandMerchantBodyFromJSONTyped = UpdateBrandMerchantBodyFromJSONTyped;
function UpdateBrandMerchantBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createMaps': value.createMaps,
    };
}
exports.UpdateBrandMerchantBodyToJSON = UpdateBrandMerchantBodyToJSON;
